import React from "react";

const generateLinePoints = (item) => {
  const total = Number(item?.total) || 1;
  const pnl = Number(item?.pnl) || 0;

  const count = Math.max(total, 2);

  const points = [];

  for (let i = 0; i < count; i++) {
    const progress = i / (count - 1);
    const value = progress * pnl;
    points.push(value);
  }

  const width = 140;
  const height = 32;

  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;

  return points
    .map((p, i) => {
      const x = (i / (count - 1)) * width;
      const y = height - ((p - min) / range) * height;
      return `${x},${y}`;
    })
    .join(" ");
};

const whatTrial = (value) => {
  switch (value) {
    case "seven":
      return "7D";
    case "thirty":
      return "1M";
    case "ninety":
      return "3M";
    case "oneEighty":
      return "6M";
    case "threeHundredSixty":
      return "1Y";
    default:
      return "";
  }
};

const PnlCards = ({ pnlData }) => {
  if (!pnlData) return null;

  return (
    <div className="signalView-grid">
      {Object.entries(pnlData).map(([key, item]) => {
        const pnlValue = Number(item?.pnl) || '0.00';

        return (
          <div key={key} className="signalView-card">
            <p className="signalView-period">{whatTrial(key)}</p>

            <p
              className={`signalView-value ${pnlValue > 0
                ? "signalView-profit" : pnlValue < 0 ?
                  'signalView-text-loss' : "signalView-default"
                }`} style={{ textAlign: 'left', width: 'auto' }}
            >
              {pnlValue > 0 ? `+${pnlValue}` : pnlValue}%
            </p>

            <p className="signalView-label">PnL</p>

            <div className="signalView-chart">
              <svg
                width="100%"
                height="32"
                viewBox="0 0 140 32"
                preserveAspectRatio="none"
              >
                <defs>
                  <linearGradient
                    id={`lineGrad-${key}`}
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0"
                  >
                    <stop
                      offset="0%"
                      stopColor={
                        pnlValue > 0
                          ? "hsl(174 72% 40% / 0.2)"
                          : pnlValue < 0 ? "hsl(0 70% 55% / 0.2)" : "hsl(215 15% 45% / 0.15)"
                      }
                    />
                    <stop
                      offset="100%"
                      stopColor={
                        pnlValue > 0
                          ? "hsl(174 72% 40% / 0.8)"
                          : pnlValue < 0 ? "hsl(0 70% 55% / 0.2)" : "hsl(215 15% 45% / 0.4)"
                      }
                    />
                  </linearGradient>
                </defs>

                <polyline
                  points={generateLinePoints(item)}
                  fill="none"
                  stroke={`url(#lineGrad-${key})`}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PnlCards;